import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';

/**
 * Remisiones: documento comercial de lo consumido fuera de paquete.
 * El folio (serie propia REM-n) lo asigna el API al crear.
 */
@Injectable({ providedIn: 'root' })
export class RemissionsService extends ApiBaseService<any> {
  constructor() {
    super('remissions');
  }
}
